import { defineComponent as _defineComponent } from 'vue'
import requestMethod from "@/composables/api/requestMethod";
import UrlConstants from "@/utils/urlconstants";
import Constants from "@/utils/constants";
import { ref, watch, inject } from "vue";
import commonModule from "@/composables/modules/commonModule";

export default /*@__PURE__*/_defineComponent({
  __name: 'commonBlobFileView',
  props: {
	Id: {
            type: String,
            default: "",
    },
	Name: {
            type: String,
            default: "",
    },
	Url: {
            type: String,
            default: "",
    },
	IsImgType:{
            type: Boolean,
            default: false,
    },
	
},
  setup(__props, { expose: __expose }) {
  __expose();

const { PatchData, GetFile } = new commonModule();
const isLoading = ref(false);
const isImage = ref(false);
const Props = __props;

const downloadFile = (id: any) => {
        GetFile(`${Props.Url}?id=${id}`, (data: any) => { 
			const blob = new Blob([data])
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = Props.Name
            link.click()
            URL.revokeObjectURL(link.href)            
        });
    }

const blobUrl = ref("");
const Fileloaded = async () => {
	isImage.value =false
	if(Props.IsImgType)
	{
		isLoading.value =true
		await requestMethod
		.GetFile(`${Props.Url}?id=${Props.Id}`)
		.then((response: any) => {
			
			blobUrl.value = ""
			if (response.isAxiosError) 
			{
				isLoading.value = false;
			} 
			else 
			{
				
				if ((response.status || 0) == 200) 
				{
					if(response.headers['content-type'].indexOf('image') != -1)
					{
						isImage.value = true
						blobUrl.value =URL.createObjectURL(response.data)
					}
				} 
				isLoading.value = false;
			}
		})
		.catch((err) => {
			isLoading.value = false;
			//toast.setMessage("error", "Unsuccessful", err, 7000);
		});
	}
	
};
Fileloaded();
watch(
	() => Props.Id,
	() => {
		Fileloaded();
	}
);

const __returned__ = { PatchData, GetFile, isLoading, isImage, Props, downloadFile, blobUrl, Fileloaded }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})